import { createRouter, createWebHistory } from 'vue-router';
import LoginView from '../views/LoginView.vue';
import RegisterView from '../views/RegisterView.vue';

import LiteratureUpload from "@/views/PaperUpload";
import PubmedView from "@/views/PubmedView";
import PushInfo from "@/views/PushInfo";
import PushPaper from "@/views/PaperDetail";
import PubmedVideo from "@/views/PubmedVideo";
import PaperRetrieve from "@/views/PaperRetrieve";
import AccountView from "@/views/account/AccountView";
import VideoTest from "@/views/VideoTest";
import PaperRecent from "@/views/mobile/PaperRecent";
import VoicePaper from "@/views/PaperDetail/VoicePaper";
import MobileHome from "@/views/mobile/MobileHome";
import MarkdownTest from "@/views/MarkdownTest";
import DoubaoPaper from "@/views/DoubaoPaper";

const routes = [
  {
    path: '/',
    name: 'home',
    component: LiteratureUpload
  },
  {
    path: '/mobile/home',
    name: 'MobileHome',
    component: MobileHome
  },
  {
    path: '/login',
    name: 'login',
    component: LoginView
  },
  {
    path: '/register',
    name: 'register',
    component: RegisterView
  },
  {
    path: '/account',
    name: 'AccountView',
    component: AccountView
  },

  {
    path: '/paper/upload',
    name: 'LiteratureUpload',
    component: LiteratureUpload
  },

  {
    path: '/paper/retrieve',
    name: 'PaperRetrieve',
    component: PaperRetrieve
  },
  {
    path: '/Push/Info',
    name: 'PushInfo',
    component: PushInfo
  },
  {
    path: '/Pubmed/Video',
    name: 'PubmedVideo',
    component: PubmedVideo
  },
  {
    path: '/Push/Paper',
    name: 'PushPaper',
    component: PushPaper
  },
  {
    path: '/Pubmed',
    name: 'Pubmed',
    component: PubmedView
  },
  {
    path: '/test',
    name: 'VideoTest',
    component: VideoTest
  },
  {
    path: '/recent',
    name: 'PaperRecent',
    component: PaperRecent
  },
  {
    path: '/paper/voice/',
    name: 'VoicePaper',
    component: VoicePaper
  },
  {
    path: '/md',
    name: 'MarkdownTest',
    component: MarkdownTest
  },
  {
    path: '/doubao',
    name: 'DoubaoPaper',
    component: DoubaoPaper
  }
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
});

export default router
